import { Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Bell, Home, MessageCircle, Menu, Search } from 'lucide-react';
import { DEVELOPMENT_COPY } from '@saesak/shared';
import { BottomNav, TabFrame, type NavItem } from '@/components/layout';
import { apiData } from '@/lib/api';

/**
 * 학부모 하단 탭 — 알림 / 쪽지 / 홈 / 돋보기 / 전체 (§7.5 v1.18).
 * 발달 돋보기는 이 서비스의 정체성이라 탭으로 승격했다(운영 결정).
 */
export function ParentShell() {
  const { data: unread } = useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: () => apiData<{ count: number }>('/notifications/unread-count'),
    refetchInterval: 60_000,
  });

  const { data: messageUnread } = useQuery({
    queryKey: ['messages', 'unread-count'],
    queryFn: () => apiData<{ count: number }>('/messages/unread-count'),
    refetchInterval: 60_000,
  });

  const items: NavItem[] = [
    { to: '/notifications', label: '알림', icon: <Bell size={20} />, badge: unread?.count },
    { to: '/messages', label: '쪽지', icon: <MessageCircle size={20} />, badge: messageUnread?.count },
    { to: '/', label: '홈', icon: <Home size={20} />, end: true },
    { to: '/scope', label: DEVELOPMENT_COPY.tabName, icon: <Search size={20} /> },
    { to: '/more', label: '전체', icon: <Menu size={20} /> },
  ];

  return (
    <TabFrame nav={<BottomNav items={items} />}>
      <Outlet />
    </TabFrame>
  );
}
